import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';

function useDDAddAction(eventName: string, shouldSend: boolean = true) {
  useEffect(() => {
    if (!shouldSend) return;
    datadogRum.addAction(eventName);
  }, [eventName, shouldSend]);
}

export default useDDAddAction;
